export const checkPhoto = (photo, type) => {
    const isWebP = photo?.toLowerCase()?.trim().endsWith('.webp');
    if (isWebP) {
        return `https://api.rositabatikshibori.com/asset/${type}/${photo}`
    } else {
        return `https://api.rositabatikshibori.com/asset/${type}/empty_photo.png`
    }
}